<template>
    <div class="card card-body">
        <!--begin::Login forgot password form-->
        <div class="login-forgot">
            <div class="mb-20">
                <h3>Forgotten Password ?</h3>
                <div class="text-muted font-weight-bold">
                    Enter your email to reset your password
                </div>
            </div>
            <!-- Error management -->
            <CustomAlerts :errors="errors"></CustomAlerts>
            <!-- Form -->
            <form class="form" method="POST" @submit.prevent="doPasswordReset">
                <div class="input-group mb-10">
                    <input
                        class="form-control h-auto form-control-solid py-4 px-8"
                        type="text"
                        placeholder="Email"
                        name="email"
                        id="kt_email"
                        autocomplete="off"
                        v-model="form.email"
                    />
                </div>
                <div class="form-group d-flex flex-wrap flex-center mt-10">
                    <button
                        id="kt_login_forgot_submit"
                        class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2"
                        @click="doPasswordReset"
                        :disabled="formIsLoading"
                        :class="(formIsLoading ? 'spinner spinner-darker-success spinner-left mr-3' : '')"
                    >
                        Request
                    </button>
                    <router-link
                        to="/login"
                        id="kt_login_forgot_cancel"
                        class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2"
                        >Cancel</router-link
                    >
                </div>
            </form>
        </div>
        <!--end::Login forgot password form-->
    </div>
</template>

<style></style>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { SET_TOKEN, SET_USER } from "@/core/services/store/auth.module";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";

export default {
    name: "ForgottenPasswordPage",
    components: {
        CustomAlerts,
    },
    data() {
        return {
            // Errors
            errors: [],

            // Form
            form: {
                email: "",
            },

            // Loaders
            formIsLoading: false,
        };
    },
    methods: {
        doPasswordReset() {
            // Reset errors
            this.errors = [];

            // Set loader
            this.formIsLoading = true;

            // Perform axios
            axios
                .post("auth/forgottenpassword", {
                    email: this.form.email,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Reset form
                        this.form.email = "";

                        // Redirect
                        setTimeout(() => {
                            this.$router.push({ name: "login" }).catch((error) => {
                                if (error.name != "NavigationDuplicated") {
                                    throw error;
                                }
                            });
                        }, 5000);
                    }

                    // Handle messages
                    if (data.messages.length > 0) {
                        data.messages.forEach((currentItem) => {
                            this.errors.push({
                                type: currentItem.type,
                                message: currentItem.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push({
                        type: "danger",
                        message:
                            "There was an issue requesting data from the API. Please refresh the page and try again.",
                    });
                    console.log(error);
                })
                .finally(() => {
                    // Close preloader
                    this.formIsLoading = false;
                });
        },
    },

    mounted() {},
};
</script>
